import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Heading, Text, Icon } from '@movember/mo-gel';

import {
  StyledOutcomesGroup,
  StyledOutcomesGroupWrapper,
  StyledHeadingAndLinkWrapper,
  StyledHeadingWrapper,
  StyledLinkWrapper,
  StyledLink,
  StyledLinkText,
  StyledHeading,
  StyledContentWrapper,
  StyledText,
  StyledHeadingTextWrapper
} from './OutcomesGroup.styled';
import { OutcomeCategory } from '../../components';
import { formatDecimalToPercentage } from '../../utils/numbers';
import { ReactComponent as EditIcon } from '../../images/icons/icon_edit.svg';

export const OutcomesGroupContainer = (props) => {
  const impactOnLifeName = 'Impact on Life';
  const { outcomes, onEdit, onViewLowLevel } = props;
  const impactOnLife = outcomes.find((outcome) => outcome.categoryName === impactOnLifeName);
  const filteredOutcomes = outcomes.filter((outcome) => outcome !== impactOnLife);

  const [blur] = useState(false);

  const handleOnEdit = (event) => {
    if (onEdit) {
      props.updateRoute({
        currentRoute: 'trt',
        previousRoute: 'results',
        title: 'trt'
      });
      return onEdit(event);
    }
    return null;
  };

  const handleOnViewLowLevel = (categoryLabel) => {
    return onViewLowLevel(categoryLabel);
  };

  const aboutTheseResults = (
    <StyledText size="xxSmall" align="left" tag="p" marginBottom="0">
      These insights are powered by data from the&nbsp;
      <StyledLink
        href={`/${window.truenth.cookies.getCookie('django_language') ||
          'en-gb'}/life-after-prostate-cancer-diagnosis/`}
      >
        <StyledLinkText>LAPCD study</StyledLinkText>
      </StyledLink>
      . Over 35,000 men participated in the study, 18 to 42 months after prostate cancer diagnosis.
    </StyledText>
  );

  const renderHeading = () => {
    return (
      <StyledHeadingWrapper>
        <StyledHeadingAndLinkWrapper>
          <StyledHeading level="h2" marginTop="1rem">
            Learn from
            <br />
            Men Like You.
          </StyledHeading>
          <StyledLinkWrapper onClick={handleOnEdit}>
            <Icon>
              <EditIcon />
            </Icon>
            <StyledLinkText level="small">Edit selections</StyledLinkText>
          </StyledLinkWrapper>
        </StyledHeadingAndLinkWrapper>
        <StyledHeadingTextWrapper>
          <Text fontWeight="bold" align="left" tag="p" marginBottom="0">
            We&apos;ve pulled together dozens of insights from men with prostate cancer. Explore each section below to
            get the real deal.
          </Text>
        </StyledHeadingTextWrapper>
        <StyledContentWrapper>
          <StyledHeadingTextWrapper>
            <Heading level="h6" marginBottom="0" marginTop="1.8rem">
              About these results
            </Heading>
            {aboutTheseResults}
          </StyledHeadingTextWrapper>
          <StyledHeadingTextWrapper>
            <Heading level="h6" marginBottom="0" marginTop="1.8rem">
              Impact on Daily life
            </Heading>
            <StyledText size="xxSmall" align="left" tag="p" marginBottom="2rem">
              {`${formatDecimalToPercentage(
                impactOnLife.highLevelInsights[0].score
              )}% of men like you said prostate cancer had a significant impact on daily life.`}
            </StyledText>
          </StyledHeadingTextWrapper>
        </StyledContentWrapper>
      </StyledHeadingWrapper>
    );
  };

  return (
    <StyledOutcomesGroupWrapper>
      {renderHeading()}
      <StyledOutcomesGroup blur={blur} id="outcomesGroup">
        {filteredOutcomes.map((category, categoryIndex) => {
          return (
            <OutcomeCategory
              category={category}
              key={`outcome-category-${categoryIndex}`}
              onViewLowLevel={handleOnViewLowLevel}
            />
          );
        })}
      </StyledOutcomesGroup>
    </StyledOutcomesGroupWrapper>
  );
};

const InsightObject = () => {
  InsightObject.propTypes = {
    id: PropTypes.string,
    label: PropTypes.string,
    score: PropTypes.number,
    phrase: PropTypes.string
  };
};

const CategoryObject = () => {
  CategoryObject.propTypes = {
    categoryName: PropTypes.string,
    highLevelInsights: PropTypes.arrayOf(InsightObject),
    lowLevelInsights: PropTypes.arrayOf(InsightObject)
  };
};

OutcomesGroupContainer.defaultProps = {
  outcomes: null,
  onEdit: () => {},
  updateRoute: () => {}
};

OutcomesGroupContainer.propTypes = {
  outcomes: PropTypes.arrayOf(CategoryObject),
  onEdit: PropTypes.func,
  updateRoute: PropTypes.func
};
